export default {
	gridUseYnList_({ useYnList }) {
		const list = [];
		useYnList.length && useYnList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	getCkuScnList_({ ckuScnList }) {
		const list = [];
		ckuScnList.length && ckuScnList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사부품 구분
	getCkuPartScnList_({ ckuPartScnList }) {
		const list = [];
		ckuPartScnList.length && ckuPartScnList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//현황부품 구분
	getSttsPartList_({ sttsPartList }) {
		const list = [];
		sttsPartList.length && sttsPartList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	getUpdatedRows_({ resultList }) {
		return resultList.filter(item => item.tableState === 'U');
	},
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000956'), //품번
				prop: 'partNo',
				minWidth: '120px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000964'), //영문품명
				prop: 'enPartNm',
				minWidth: '180px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000965'), //한글품명
				prop: 'koPartNm',
				minWidth: '180px',
				form: {
					type: 'input',
					maxLength: 200
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000966'), //중문품명
				prop: 'chPartNm',
				minWidth: '180px',
				form: {
					type: 'input',
					maxLength: 150
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('MWPQ000006'), //검사시간
				prop: 'ckuTm',
				minWidth: '90px',
				custom: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000987'), //검사구분코드
				prop: 'ckuScnCd',
				minWidth: '80px',
				form: {
					type: 'select',
					options: getters.getCkuScnList_
				}
			},
			{
				//검사부품구분
				label: rootGetters['commonStore/getMessage_']('QWCC001915'), //검사부품구분코드
				prop: 'ckuPartScnCd',
				minWidth: '90px',
				form: {
					type: 'select',
					options: getters.getCkuPartScnList_
				}
			},
			{
				//현황부품구분
				label: rootGetters['commonStore/getMessage_']('QWCC001922'), //현황부품구분코드
				prop: 'sttsPartCd',
				minWidth: '80px',
				form: {
					type: 'select',
					options: getters.getSttsPartList_
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000958'), //협력사
				prop: 'cofCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000958'), //협력사
				prop: 'oldCofNm',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000958'), //협력사
				prop: 'newCofNm',
				minWidth: '190px',
				custom: true
			},
			{
				// 부품그룹
				label: rootGetters['commonStore/getMessage_']('QWCC000981'),
				prop: 'partGCd',
				minWidth: '1px'
			},
			{
				// 부품그룹
				label: rootGetters['commonStore/getMessage_']('QWCC000981'),
				prop: 'partGNm',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000968'), //기본단위
				prop: 'bascUtm',
				minWidth: '80px'
			},
			{
				// 사용여부
				label: rootGetters['commonStore/getMessage_']('MWCC000891'),
				prop: 'useYnNm',
				minWidth: '70px'
			},
			{
				// 사용여부
				label: rootGetters['commonStore/getMessage_']('MWCC000891'),
				prop: 'useYn',
				minWidth: '1px'
			}
		];
	}
};
